class CustomError extends Error {
    constructor(...args){
        super(...args), this.needLog = true;
    }
}

export { CustomError };
//# sourceMappingURL=custom.error.js.map
